/* DrBali premium cart V3 runtime (drbali-cart-premium section) */
(() => {
  'use strict';

  const configNode = document.querySelector('[data-drbali-cart-v2]');
  if (!configNode) return;
  const d = configNode.dataset;

  const config = {
    eyebrow: d.eyebrow || 'Dr. Bali',
    heading: d.heading || 'Sepetiniz',
    emptyHeading: d.emptyHeading || 'Sepetiniz henüz boş.',
    emptyText: d.emptyText || '',
    continueLabel: d.continueLabel || 'Ürünleri keşfet',
    continueUrl: d.continueUrl || '/collections/tum-urunler',
    checkoutLabel: d.checkoutLabel || 'Ödemeye geç',
    subtotalLabel: (function (l) { l = (l || 'Ara toplam').replace('Tahmini toplam', 'Ara toplam'); return /KDV/i.test(l) ? l : l + ' (KDV dahil)'; })(d.subtotalLabel),
    deliveryNote: d.deliveryNote || '',
    shippingRates: d.shippingRates || '',
    currency: d.currency || 'TRY',
    cartUrl: d.cartUrl || '/cart',
    cartJsonUrl: d.cartJsonUrl || '/cart.js',
    cartAddUrl: d.cartAddUrl || '/cart/add',
    cartChangeUrl: d.cartChangeUrl || '/cart/change'
  };

  let compareAt = {};
  try { compareAt = JSON.parse(document.getElementById('DrBaliCartV2Compare')?.textContent || '{}'); } catch (_) {}

  const MSG = {
    network: 'Bağlantı kurulamadı. Lütfen tekrar deneyin.',
    generic: 'Sepet güncellenemedi. Lütfen tekrar deneyin.',
    add: 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.',
    stock: (n) => n > 0 ? 'Stokta bu üründen yalnızca ' + n + ' adet var.' : 'Bu ürün şu anda stokta yok.'
  };

  let drawer = null;
  let shell = null;
  let body = null;
  let footer = null;
  let observer = null;
  let renderLock = false;
  let refreshTimer = null;
  let currentCart = null;
  const quantityJobs = new Map();
  const lineErrors = new Map();

  const escapeHtml = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: config.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (_) {
      return value.toFixed(2) + ' ' + config.currency;
    }
  };

  const icon = {
    info: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.25" fill="none" stroke="currentColor" stroke-width="1.35"/><path d="M12 10.5v5M12 7.8h.01" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6.5h11v9H3zM14 9.5h4l3 3v3h-7" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linejoin="round"/><circle cx="7" cy="17.5" r="1.6" fill="none" stroke="currentColor" stroke-width="1.35"/><circle cx="17" cy="17.5" r="1.6" fill="none" stroke="currentColor" stroke-width="1.35"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 8v9M12 8v9M16 8v9M5 5h14M9 5V3.5h6V5M6.5 5l.7 15h9.6l.7-15" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  const isOpen = () => !!drawer && drawer.classList.contains('active');

  const closeDrawer = () => {
    if (!drawer) return;
    if (typeof drawer.close === 'function') return drawer.close();
    const overlay = drawer.querySelector('.cart-drawer__overlay');
    if (overlay) return overlay.click();
    drawer.classList.remove('active');
  };

  const openDrawer = () => {
    if (!drawer) return;
    if (typeof drawer.open === 'function') return drawer.open();
    drawer.classList.add('animate');
    requestAnimationFrame(() => drawer.classList.add('active'));
  };

  /* ---------- focus: our own trap, the shell is re-rendered so Dawn's cached list goes stale ---------- */
  const focusables = () => shell ? Array.from(shell.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((el) => el.offsetParent !== null || el === document.activeElement) : [];

  const onKeydown = (event) => {
    if (event.key !== 'Tab' || !isOpen() || !shell) return;
    const list = focusables();
    if (!list.length) return;
    const first = list[0];
    const last = list[list.length - 1];
    const active = document.activeElement;
    const inside = shell.contains(active);
    if (event.shiftKey && (active === first || !inside)) {
      event.preventDefault(); event.stopImmediatePropagation(); last.focus();
    } else if (!event.shiftKey && (active === last || !inside)) {
      event.preventDefault(); event.stopImmediatePropagation(); first.focus();
    }
  };

  const onFocusIn = (event) => {
    if (!isOpen() || !shell || shell.contains(event.target)) return;
    if (drawer.contains(event.target) && event.target.closest('.drawer__inner') && !event.target.closest('.drbali-cart-v2-shell')) {
      shell.querySelector('[data-db-cart-close]')?.focus();
    }
  };

  const createShell = () => {
    if (!drawer) return false;
    const inner = drawer.querySelector('.drawer__inner');
    if (!inner) return false;

    const existing = inner.querySelector('.drbali-cart-v2-shell');
    if (existing) {
      shell = existing;
      body = shell.querySelector('[data-db-cart-body]');
      footer = shell.querySelector('[data-db-cart-footer]');
      drawer.classList.add('drbali-cart-v2-ready');
      return true;
    }

    renderLock = true;
    const legal = document.getElementById('DrBaliCartV2Legal')?.innerHTML.trim() || '';

    shell = document.createElement('div');
    shell.className = 'drbali-cart-v2-shell';
    shell.setAttribute('role', 'dialog');
    shell.setAttribute('aria-modal', 'true');
    shell.setAttribute('aria-labelledby', 'DrBaliCartV2Title');
    shell.innerHTML = `
      <header class="drbali-cart-v2-header">
        <div>
          <p class="drbali-cart-v2-eyebrow">
            <span>${escapeHtml(config.eyebrow)}</span>
            <span class="drbali-cart-v2-count" data-db-cart-count></span>
          </p>
          <h2 class="drbali-cart-v2-title" id="DrBaliCartV2Title">${escapeHtml(config.heading)}</h2>
        </div>
        <button class="drbali-cart-v2-close" type="button" data-db-cart-close aria-label="Sepeti kapat">${icon.close}</button>
      </header>
      <div class="drbali-cart-v2-body" data-db-cart-body></div>
      <p class="visually-hidden" aria-live="polite" data-db-cart-live></p>
      <footer class="drbali-cart-v2-footer" data-db-cart-footer hidden>
        <div data-db-cart-discounts></div>
        <div class="drbali-cart-v2-total">
          <span>${escapeHtml(config.subtotalLabel)}</span>
          <strong data-db-cart-total></strong>
        </div>
        ${config.shippingRates ? `<p class="drbali-cart-v2-note">${icon.truck}<span>${escapeHtml(config.shippingRates)}</span></p>` : ''}
        ${config.deliveryNote ? `<p class="drbali-cart-v2-note">${icon.info}<span>${escapeHtml(config.deliveryNote)}</span></p>` : ''}
        <form action="${escapeHtml(config.cartUrl)}" method="post">
          <button class="drbali-cart-v2-checkout" type="submit" name="checkout">${escapeHtml(config.checkoutLabel)}</button>
        </form>
        ${legal}
      </footer>
    `;

    inner.appendChild(shell);
    body = shell.querySelector('[data-db-cart-body]');
    footer = shell.querySelector('[data-db-cart-footer]');

    shell.querySelector('[data-db-cart-close]')?.addEventListener('click', closeDrawer);
    body?.addEventListener('click', onBodyClick);

    drawer.classList.add('drbali-cart-v2-ready');
    renderLock = false;
    return true;
  };

  const announce = (text) => {
    const live = shell?.querySelector('[data-db-cart-live]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(() => { live.textContent = text; }, 40);
  };

  const syncHeaderCartCount = (cart) => {
    const cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink || !cart) return;

    const count = Math.max(0, Number(cart.item_count || 0));
    let bubble = cartLink.querySelector('.cart-count-bubble');

    if (count <= 0) {
      bubble?.remove();
      cartLink.setAttribute('aria-label', 'Sepet');
      return;
    }

    if (!bubble) {
      bubble = document.createElement('span');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartLink.appendChild(bubble);
    }

    let visibleCount = bubble.querySelector('[aria-hidden="true"]');
    if (!visibleCount) {
      visibleCount = document.createElement('span');
      visibleCount.setAttribute('aria-hidden', 'true');
      bubble.prepend(visibleCount);
    }

    let accessibleCount = bubble.querySelector('.visually-hidden');
    if (!accessibleCount) {
      accessibleCount = document.createElement('span');
      accessibleCount.className = 'visually-hidden';
      bubble.appendChild(accessibleCount);
    }

    visibleCount.textContent = count < 100 ? String(count) : '99+';
    accessibleCount.textContent = count + ' ürün sepette';
    cartLink.setAttribute('aria-label', 'Sepet, ' + count + ' ürün');
  };

  /* ---------- line markup ---------- */
  const priceHtml = (item) => {
    const final = Number(item.final_line_price ?? item.line_price ?? 0);
    const qty = Number(item.quantity || 0);
    const compareUnit = Number(compareAt[String(item.variant_id)] || 0);
    const before = Math.max(Number(item.original_line_price ?? item.line_price ?? 0), compareUnit * qty);
    return (before > final ? `<s>${money(before)}</s>` : '') + `<span>${money(final)}</span>`;
  };

  const discountsHtml = (item) => {
    const list = Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : [];
    if (!list.length) return '';
    return `<ul class="drbali-cart-v2-disc">${list.map((a) => `<li>${escapeHtml(a.discount_application?.title || 'İndirim')} (−${money(a.amount)})</li>`).join('')}</ul>`;
  };

  const itemHtml = (item) => {
    const name = item.product_title || item.title || '';
    const url = escapeHtml(item.url || '#');
    const image = item.image
      ? `<a class="drbali-cart-v2-media" href="${url}" tabindex="-1" aria-hidden="true"><img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="92" height="107"></a>`
      : `<a class="drbali-cart-v2-media" href="${url}" tabindex="-1" aria-hidden="true"></a>`;
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<div class="drbali-cart-v2-variant">${escapeHtml(item.variant_title)}</div>` : '';
    const qty = Number(item.quantity || 0);
    const err = lineErrors.get(item.key) || '';

    return `
      <li class="drbali-cart-v2-item" data-db-key="${escapeHtml(item.key || '')}" data-db-handle="${escapeHtml(item.handle || '')}">
        ${image}
        <div class="drbali-cart-v2-item-body">
          <a class="drbali-cart-v2-name" href="${url}">${escapeHtml(name)}</a>
          ${variant}
          <div class="drbali-cart-v2-price" data-db-price>${priceHtml(item)}</div>
          <div data-db-disc>${discountsHtml(item)}</div>
          <div class="drbali-cart-v2-actions">
            <div class="drbali-cart-v2-qty" role="group" aria-label="${escapeHtml(name)} adedi">
              <button type="button" data-db-qty="-1" aria-label="Adedi azalt"${qty <= 1 ? ' disabled' : ''}>−</button>
              <output aria-live="polite">${qty}</output>
              <button type="button" data-db-qty="1" aria-label="Adedi artır">+</button>
            </div>
            <button class="drbali-cart-v2-remove" type="button" data-db-remove aria-label="${escapeHtml(name)} ürününü sepetten çıkar">${icon.trash}</button>
          </div>
          <p class="drbali-cart-v2-error" role="alert" data-db-error>${escapeHtml(err)}</p>
        </div>
      </li>
    `;
  };

  const renderTotals = (cart) => {
    const count = Number(cart.item_count || 0);
    const countNode = shell.querySelector('[data-db-cart-count]');
    const totalNode = shell.querySelector('[data-db-cart-total]');
    const discNode = shell.querySelector('[data-db-cart-discounts]');

    if (countNode) countNode.textContent = count ? '· ' + count + ' ürün' : '';
    if (totalNode) totalNode.textContent = money(cart.total_price || 0);
    if (discNode) {
      const apps = Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];
      discNode.innerHTML = apps.map((a) => `<p class="drbali-cart-v2-row"><span>${escapeHtml(a.title || 'İndirim')}</span><span>−${money(a.total_allocated_amount)}</span></p>`).join('');
    }
    drawer?.classList.remove('is-empty');
  };

  const renderEmpty = () => {
    footer.hidden = true;
    const tpl = document.getElementById('DrBaliCartV2Empty');
    body.innerHTML = tpl ? tpl.innerHTML : `
      <div class="drbali-cart-v2-empty">
        <h3>${escapeHtml(config.emptyHeading)}</h3>
        ${config.emptyText ? `<p>${escapeHtml(config.emptyText)}</p>` : ''}
        <div class="drbali-cart-v2-empty-actions"><a class="drbali-cart-v2-btn" href="${escapeHtml(config.continueUrl)}">${escapeHtml(config.continueLabel)}</a></div>
      </div>`;
  };

  const renderCart = (cart) => {
    if (!shell || !body || !footer || !cart) return;

    currentCart = cart;
    syncHeaderCartCount(cart);
    renderTotals(cart);

    if (Number(cart.item_count || 0) === 0) {
      lineErrors.clear();
      renderEmpty();
      return;
    }

    footer.hidden = false;
    const items = Array.isArray(cart.items) ? cart.items : [];
    const activeKey = document.activeElement?.closest?.('.drbali-cart-v2-item')?.dataset.dbKey;
    const activeRole = document.activeElement?.matches?.('[data-db-qty="1"]') ? '[data-db-qty="1"]'
      : document.activeElement?.matches?.('[data-db-qty="-1"]') ? '[data-db-qty="-1"]' : null;

    body.innerHTML = `<ul class="drbali-cart-v2-list" role="list">${items.map(itemHtml).join('')}</ul>`;

    if (activeKey && activeRole) {
      const node = body.querySelector('[data-db-key="' + CSS.escape(activeKey) + '"] ' + activeRole);
      if (node && !node.disabled) node.focus();
    }
  };

  /* Update only what changed; the line keeps its DOM (and the user's focus). */
  const patchCart = (cart) => {
    if (!shell || !body || !cart) return;
    const items = Array.isArray(cart.items) ? cart.items : [];
    const nodes = Array.from(body.querySelectorAll('.drbali-cart-v2-item'));
    const keys = new Set(items.map((i) => i.key));

    if (!items.length || !nodes.length) return renderCart(cart);

    const removed = nodes.filter((n) => !keys.has(n.dataset.dbKey));
    const shownKeys = new Set(nodes.map((n) => n.dataset.dbKey));
    if (items.some((i) => !shownKeys.has(i.key))) return renderCart(cart);

    currentCart = cart;
    syncHeaderCartCount(cart);
    renderTotals(cart);

    removed.forEach((node) => {
      const hadFocus = node.contains(document.activeElement);
      const next = node.nextElementSibling || node.previousElementSibling;
      lineErrors.delete(node.dataset.dbKey);
      node.remove();
      if (hadFocus) (next?.querySelector('.drbali-cart-v2-name') || shell.querySelector('[data-db-cart-close]'))?.focus();
    });

    items.forEach((item) => {
      const node = body.querySelector('[data-db-key="' + CSS.escape(item.key) + '"]');
      if (!node) return;
      const qty = Number(item.quantity || 0);
      const job = quantityJobs.get(item.key);
      const price = node.querySelector('[data-db-price]');
      const disc = node.querySelector('[data-db-disc]');
      if (price) price.innerHTML = priceHtml(item);
      if (disc) disc.innerHTML = discountsHtml(item);
      if (!job) setDisplayedQuantity(item.key, qty);
      const err = node.querySelector('[data-db-error]');
      if (err) err.textContent = lineErrors.get(item.key) || '';
    });
  };

  const fetchCart = async () => {
    const joiner = config.cartJsonUrl.includes('?') ? '&' : '?';
    const response = await fetch(config.cartJsonUrl + joiner + '_db=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('cart');
    return response.json();
  };

  const refreshCart = async (openAfter = false) => {
    if (!drawer) return;

    const hasPendingQuantity = Array.from(quantityJobs.values()).some((job) => job.inFlight || job.timer);
    if (hasPendingQuantity && !openAfter) return;

    try {
      const cart = await fetchCart();
      createShell();
      renderCart(cart);
      if (openAfter) openDrawer();
    } catch (error) {
      console.error('[DrBali Cart V3]', error);
    }
  };

  const setPendingVisual = (key, pending) => {
    const itemNode = body?.querySelector('[data-db-key="' + CSS.escape(key) + '"]');
    if (!itemNode) return;
    if (pending) itemNode.setAttribute('aria-busy', 'true');
    else itemNode.removeAttribute('aria-busy');
    itemNode.querySelector('.drbali-cart-v2-qty')?.classList.toggle('is-pending', pending);
  };

  const setDisplayedQuantity = (key, quantity) => {
    const itemNode = body?.querySelector('[data-db-key="' + CSS.escape(key) + '"]');
    const qtyNode = itemNode?.querySelector('.drbali-cart-v2-qty output');
    if (qtyNode) qtyNode.textContent = String(Math.max(0, quantity));
    const minus = itemNode?.querySelector('[data-db-qty="-1"]');
    if (minus) {
      const wasFocused = document.activeElement === minus;
      minus.disabled = quantity <= 1;
      if (wasFocused && minus.disabled) itemNode.querySelector('[data-db-qty="1"]')?.focus();
    }
  };

  const setLineError = (key, message) => {
    if (message) lineErrors.set(key, message); else lineErrors.delete(key);
    const node = body?.querySelector('[data-db-key="' + CSS.escape(key) + '"] [data-db-error]');
    if (node) node.textContent = message || '';
  };

  const sendQuantityJob = async (key) => {
    const job = quantityJobs.get(key);
    if (!job || job.inFlight) return;

    job.inFlight = true;
    job.timer = null;
    const sentQuantity = job.desired;
    setPendingVisual(key, true);

    try {
      let response;
      try {
        response = await fetch(config.cartChangeUrl + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: key, quantity: sentQuantity })
        });
      } catch (_) {
        const e = new Error(MSG.network); e.kind = 'network'; throw e;
      }

      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.status) {
        const e = new Error(data.description || data.message || MSG.generic); e.kind = 'server'; throw e;
      }

      const cart = data;
      currentCart = cart;

      const liveJob = quantityJobs.get(key);
      if (liveJob && liveJob.desired !== sentQuantity) {
        liveJob.inFlight = false;
        setDisplayedQuantity(key, liveJob.desired);
        window.clearTimeout(liveJob.timer);
        liveJob.timer = window.setTimeout(() => sendQuantityJob(key), 90);
        return;
      }

      quantityJobs.delete(key);
      setLineError(key, '');
      createShell();
      patchCart(cart);
      if (sentQuantity === 0) announce('Ürün sepetten çıkarıldı.');
      else announce('Adet ' + sentQuantity + ' olarak güncellendi.');
      document.dispatchEvent(new CustomEvent('drbali:cart:changed', { detail: { cart, key } }));
    } catch (error) {
      quantityJobs.delete(key);
      let message = error.kind === 'network' ? MSG.network : MSG.generic;
      try {
        const cart = await fetchCart();
        const line = (cart.items || []).find((i) => i.key === key);
        const have = line ? Number(line.quantity || 0) : 0;
        if (error.kind === 'server' && sentQuantity > have) message = MSG.stock(have);
        createShell();
        setLineError(key, message);
        patchCart(cart);
      } catch (_) {
        setLineError(key, message);
      }
      announce(message);
    } finally {
      const liveJob = quantityJobs.get(key);
      if (!liveJob || !liveJob.inFlight) setPendingVisual(key, false);
    }
  };

  const queueQuantityChange = (key, quantity) => {
    if (!key || !Number.isInteger(quantity) || quantity < 0) return;

    const existing = quantityJobs.get(key) || { desired: quantity, inFlight: false, timer: null };
    existing.desired = quantity;
    quantityJobs.set(key, existing);

    setLineError(key, '');
    setDisplayedQuantity(key, quantity);
    setPendingVisual(key, true);

    if (existing.inFlight) return;
    window.clearTimeout(existing.timer);
    existing.timer = window.setTimeout(() => sendQuantityJob(key), 150);
  };

  const removeItem = (key) => {
    if (!key) return;
    const job = quantityJobs.get(key);
    if (job?.timer) window.clearTimeout(job.timer);
    quantityJobs.delete(key);
    queueQuantityChange(key, 0);
  };

  function onBodyClick(event) {
    const item = event.target.closest('.drbali-cart-v2-item');
    if (!item) return;

    const key = item.dataset.dbKey || '';
    const shownQty = Number(item.querySelector('.drbali-cart-v2-qty output')?.textContent || 0);
    const pendingJob = quantityJobs.get(key);
    const baseQty = pendingJob ? pendingJob.desired : shownQty;

    const qtyButton = event.target.closest('[data-db-qty]');
    if (qtyButton) {
      event.preventDefault();
      const delta = Number(qtyButton.dataset.dbQty || 0);
      queueQuantityChange(key, Math.max(1, baseQty + delta));
      return;
    }

    if (event.target.closest('[data-db-remove]')) {
      event.preventDefault();
      removeItem(key);
    }
  }

  /* ---------- add-to-cart error near the button ---------- */
  const showAddError = (form, submitter, message) => {
    const anchor = submitter || form.querySelector('[type="submit"]') || form.lastElementChild;
    if (!anchor) return;
    let node = form.querySelector('.drbali-cart-v2-add-error');
    if (!node) {
      node = document.createElement('p');
      node.className = 'drbali-cart-v2-add-error';
      node.setAttribute('role', 'alert');
      anchor.insertAdjacentElement('afterend', node);
    }
    node.textContent = message;
    window.clearTimeout(node._t);
    node._t = window.setTimeout(() => node.remove(), 7000);
  };

  const addErrorMessage = async (form, raw) => {
    const text = String(raw || '');
    const id = Number(new FormData(form).get('id') || 0);
    if (/stok|stock|sold out|tükendi|only|yalnızca|available|mevcut/i.test(text) && id) {
      try {
        const cart = await fetchCart();
        const inCart = (cart.items || []).filter((i) => i.variant_id === id).reduce((s, i) => s + Number(i.quantity || 0), 0);
        if (inCart > 0) return 'Stoktaki adetlerin tümü sepetinizde (' + inCart + ' adet).';
        return MSG.stock(0);
      } catch (_) {}
    }
    return text && text.length < 160 ? text : MSG.add;
  };

  const bridgePlainForms = () => {
    if (document.documentElement.dataset.drbaliSilentAddBridge === 'true') return;
    document.documentElement.dataset.drbaliSilentAddBridge = 'true';

    const setButtonState = (button, state) => {
      if (!button) return;

      const findLabel = () =>
        button.querySelector('[data-drbali-qv-add-text]') ||
        button.querySelector('.product-form__submit span:not(.loading__spinner)') ||
        button.querySelector('span');
      const label = findLabel();

      if (state === 'loading') {
        if (!button.dataset.drbaliOriginalLabel && label) button.dataset.drbaliOriginalLabel = label.textContent || '';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.classList.add('is-loading');
        if (label) label.textContent = 'Ekleniyor…';
        return;
      }

      if (state === 'success') {
        button.disabled = true;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        if (label) label.textContent = 'Eklendi ✓';

        window.setTimeout(() => {
          const liveLabel = findLabel();
          if (liveLabel && button.dataset.drbaliOriginalLabel) liveLabel.textContent = button.dataset.drbaliOriginalLabel;
          button.disabled = false;
          delete button.dataset.drbaliOriginalLabel;
        }, 1200);
        return;
      }

      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
      if (label && button.dataset.drbaliOriginalLabel) label.textContent = button.dataset.drbaliOriginalLabel;
      delete button.dataset.drbaliOriginalLabel;
    };

    /*
      Capture phase is intentional: it runs before Dawn's <product-form> submit
      handler, so every storefront add-to-cart uses the same silent AJAX flow.
    */
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitter =
        event.submitter ||
        form.querySelector('[type="submit"][name="add"]') ||
        form.querySelector('[type="submit"]');

      if (submitter?.disabled) return;

      form.querySelector('.drbali-cart-v2-add-error')?.remove();
      setButtonState(submitter, 'loading');

      try {
        const formData = new FormData(form);
        formData.delete('sections');
        formData.delete('sections_url');

        const addUrl = config.cartAddUrl.endsWith('.js') ? config.cartAddUrl : config.cartAddUrl + '.js';

        let response;
        try {
          response = await fetch(addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
        } catch (_) {
          throw new Error(MSG.network);
        }

        const result = await response.json().catch(() => ({}));
        if (!response.ok || result.status) throw new Error(result.description || result.message || MSG.add);

        await refreshCart(false);
        setButtonState(submitter, 'success');

        document.dispatchEvent(new CustomEvent('drbali:cart:silent-updated', {
          bubbles: true,
          detail: { source: 'global-add-to-cart', response: result }
        }));
      } catch (error) {
        console.error('[DrBali Silent Add]', error);
        setButtonState(submitter, 'idle');
        const message = error?.message === MSG.network ? MSG.network : await addErrorMessage(form, error?.message);
        showAddError(form, submitter, message);
        form.dispatchEvent(new CustomEvent('drbali:cart:error', { bubbles: true, detail: { message } }));
      }
    }, true);
  };

  const bindDrawer = () => {
    drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    createShell();
    refreshCart(false);

    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('focusin', onFocusIn);

    /* when opened, move focus into our shell once Dawn has finished its own focus step */
    new MutationObserver(() => {
      if (!isOpen()) return;
      window.setTimeout(() => {
        if (isOpen() && shell && !shell.contains(document.activeElement)) shell.querySelector('[data-db-cart-close]')?.focus();
      }, 420);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    observer?.disconnect();
    observer = new MutationObserver((mutations) => {
      if (renderLock) return;
      const externalMutation = mutations.some((mutation) => {
        const target = mutation.target;
        return !(target instanceof Element && target.closest('.drbali-cart-v2-shell'));
      });
      if (!externalMutation) return;
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(() => { createShell(); refreshCart(false); }, 120);
    });
    observer.observe(drawer, { childList: true, subtree: true });

    if (window.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => {
          window.clearTimeout(refreshTimer);
          refreshTimer = window.setTimeout(() => refreshCart(false), 120);
        });
      } catch (_) {}
    }

    window.DrBaliCart = { refresh: refreshCart, get cart() { return currentCart; } };
    return true;
  };

  bridgePlainForms();

  if (!bindDrawer()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (bindDrawer() || attempts > 40) window.clearInterval(timer);
    }, 250);
  }
})();
